export const getProductsElements = (products) => {
  return products.map((product) => {
    return decodeURI(product.product_tile);
  }).join('');
};
